<div class="is-loading active" *ngIf="isLoading">
</div>
<ng-container *ngIf="!isLoading && GenericPage">
    <div *ngIf="GenericPage.heroBlock" class="contentfulTextBlock">
        <p>{{GenericPage.heroBlock.text}}</p>
    </div>
    <div class="contentRows">
        <ng-container *ngFor="let contentRow of GenericPage.contentRows">
            <sbw-contentful-content-row [ContentRow]="contentRow" (onToggleExpandRow)="onToggleExpandRow($event)" [InfoBlockBehaviour]="InfoBlockBehaviour"></sbw-contentful-content-row>
        </ng-container>
    </div>

</ng-container>

